// extracted by mini-css-extract-plugin
module.exports = {"switch_border_radius":"styles_switch_border_radius__3U4xQ"};